import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./alerts.css";
import store from "./redux/store";
import { Provider } from 'react-redux'
import { positions, transitions, Provider as AlertProvider } from 'react-alert'

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CloseIcon from '@material-ui/icons/Close';

const CustomAlertTemplate = ({ style, options, message, close }) => {
  const isError = options.type === 'error';
  const isSuccess = options.type === 'success';

  let bgColor = '#111111';
  let borderColor = 'rgba(255, 255, 255, 0.12)';
  let textColor = '#ffffff';
  let icon = <InfoOutlinedIcon style={{ color: '#3b82f6', marginRight: '12px', fontSize: '20px' }} />;

  if (isError) {
    bgColor = '#fef2f2';
    borderColor = '#fca5a5';
    textColor = '#991b1b';
    icon = <ErrorOutlineIcon style={{ color: '#ef4444', marginRight: '12px', fontSize: '20px' }} />;
  } else if (isSuccess) {
    bgColor = '#f0fdf4';
    borderColor = '#bbf7d0';
    textColor = '#166534';
    icon = <CheckCircleOutlineIcon style={{ color: '#22c55e', marginRight: '12px', fontSize: '20px' }} />;
  }

  return (
    <div
      style={{
        ...style,
        display: 'flex',
        alignItems: 'center',
        padding: '14px 20px',
        backgroundColor: bgColor,
        border: `1px solid ${borderColor}`,
        borderRadius: '8px',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.15)',
        color: textColor,
        fontFamily: 'Inter, system-ui, sans-serif',
        fontSize: '14px',
        fontWeight: '600',
        minWidth: '320px',
        justifyContent: 'space-between',
        pointerEvents: 'all'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {icon}
        <span>{message}</span>
      </div>
      <button
        onClick={close}
        style={{
          background: 'none',
          border: 'none',
          color: textColor,
          cursor: 'pointer',
          padding: '4px',
          display: 'flex',
          alignItems: 'center',
          opacity: 0.7,
          marginLeft: '16px',
          outline: 'none'
        }}
      >
        <CloseIcon style={{ fontSize: '18px' }} />
      </button>
    </div>
  );
};

const option = {
  timeout: 5000,
  positions: positions.TOP_CENTER,
  transitions: transitions.FADE
}

ReactDOM.render(
  < Provider store={store}>
    <AlertProvider template={CustomAlertTemplate} {...option}  >
      <App />
    </AlertProvider>
  </Provider>,
  document.getElementById("root")
);



// <Provider store={store}>